import { render, staticRenderFns } from "./DataAdminEntity.vue?vue&type=template&id=470e5280&"
import script from "./DataAdminEntity.vue?vue&type=script&lang=js&"
export * from "./DataAdminEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports